import React, { useEffect, useState } from "react";
import "./css/ProductsMainArea.scss";
import Axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import QuoteForm from "./QuoteForm";
import PopupQuoote from "./PopupQuoote";
import { FaChevronRight } from "react-icons/fa";
import ScrollLock from "../ScrollLock.js";
import { useStateValue } from "../StateProvider";
import ProductBox from "./ProductBox";
import "./css/ProductBox.scss";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import SupplementaryServices from "./SupplementaryServices.jsx";

//   main product area

function Tab(props) {
  const [{ Product }, dispatch] = useStateValue();

  const [blockScroll, allowScroll] = ScrollLock();

  const [read, setRead] = useState("");

  const ToggleRead = (item) => {
    if (read == item.id) {
      setRead(false);
    } else {
      setRead(item.id);
    }
  };
  const [isOpen, setIsOpen] = useState(false);

  const miniForm = (item) => {
    setIsOpen(true);
    setSp(item);
    blockScroll();
  };
  const [sp, setSp] = useState({});
  const [mp, setMp] = useState([]);

  const GoDetail = (item) => {
    dispatch({
      type: "SET_PRODUCT",
      Product: item,
    });
  };

  return (
    <div className={`tabs__content`}>
      {props.tab.products ? props.tab.products.map((item) => (
        <ProductBox
          key={item.id}
          item={item}
          GoDetail={() => {
            GoDetail(item);
          }}
          miniForm={() => {
            miniForm(item);
          }}
          ToggleRead={() => {
            ToggleRead(item);
          }}
          read={read}
        />
      )) : null}

      <PopupQuoote
        open={isOpen}
        allowScroll={allowScroll}
        onClose={() => {
          setIsOpen(false);
        }}
        product={sp}
      />
    </div>
  );
}


function ProductsMainArea() {
  const [Tabs, setTabs] = useState([]);
  let url = window.location.href.split("/").pop();

  const [selectedSubcategory, setSelectedSubcategory] = useState([]);
  const [activeCat, setActiveCat] = useState(0)

  const navigate = useNavigate();
  // navigate(`/product-category/${item.slug}`);
  useEffect(() => {
    Axios.get("https://hutaib.admin.simboz.website/api/products/get-products")
      .then((res) => {
        setTabs(res.data.cats);
        let pro = res.data.cats;
        for (let a = 0; a <= pro.length - 1; a++) {
          if (url.trim() === pro[a].slug.trim()) {
            if (pro[a].products.length > 0) {
              setSelectedSubcategory(pro[a])
            }
            else {
              setSelectedSubcategory(pro[a])

            }
            console.log("Test Pass")
            break;
          } else {
            for (let b = 0; b <= pro[a].subcategories.length - 1; b++) {
              console.log(pro[a].subcategories[b], "Test")
              if (url.trim() === pro[a].subcategories[b].slug.trim()) {
                setSelectedSubcategory(pro[a].subcategories[b])
              }
            }
            console.log('Test Fail')
          }
        }
      })
      .catch((err) => {
      });
    // https://hutaib.admin.simboz.website/api/products/get-cat-pro/${url}
  }, [url]);

  let showProducts = (e, data) => {
    console.log(data, "data")
    if (data.products.length > 0) {
      setSelectedSubcategory(data)
    } else {
      navigate(`/product-category/${data.slug}`);
    }
  }

  let [slideOut, setSlideOut] = useState(false)
  return (
    <>
      <div className="ProductsMainArea">

        {/* working code */}
        {Tabs.length > 0 ? (
          <div className="inner">
            <div className={slideOut ? "category_side slideOut" : "category_side "} >
              <div className="handleController" onClick={() => { setSlideOut(!slideOut) }}>
                <FaChevronRight className="iconToggle" />
              </div>
              <div className="inner">
                <div className={`tabs`}>
                  <ul>
                    {Tabs.map((item, index) => {
                      return (
                        <li key={index}>
                          <span className={item.id == selectedSubcategory.id ? "listItem activeBtn" : "listItem mainCate"} onClick={(e) => showProducts(e, item)}>{item.category}</span>
                          {item.subcategories ?
                            <ul>
                              {item.subcategories.map((item, index) => {
                                return (
                                  <li key={index}>
                                    <span className={item.id == selectedSubcategory.id ? "listItem activeBtn" : "listItem"} onClick={(e) => showProducts(e, item)}>{item.category}</span>
                                  </li>
                                )
                              })}
                            </ul>
                            : null
                          }
                        </li>
                      )
                    })}
                  </ul>
                </div>
              </div>
            </div>

            <div className="product_side">
              <div className="inner">
                <Tab tab={selectedSubcategory} />
                {console.log(selectedSubcategory, "selectedSubcategory")}
                {selectedSubcategory.meta_footer ? (
                  <div
                    dangerouslySetInnerHTML={{ __html: selectedSubcategory.meta_footer }}
                    className="seocontent"
                  ></div>
                ) : null}
              </div>
            </div>

          </div>
        ) : (
          <div className="loader_container">
            <img className="product_loader" src="../assets/images/loader.gif" />
          </div>
        )}
      </div >
    </>
  );
}

export default ProductsMainArea;
